import React from 'react';
import styled from 'styled-components';
import { RGBA_COLORS } from '../../utils/colors';

interface ButtonsProps {
  onClick: () => void;
  type: 'button' | 'submit';
  title: string;
}

export const DefButton: React.FC<ButtonsProps> = ({ onClick, type = 'button', title }) => {
  return (
    <BtnS onClick={onClick} type={type}>
      {title}
    </BtnS>
  );
};

export const BtnS = styled.button`
  display: inline-block;
  margin-bottom: 0px;
  font-weight: 500;
  text-align: center;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid rgb(233, 233, 233);
  white-space: nowrap;
  line-height: 1.5;
  padding: 0px 25px;
  font-size: 14px;
  border-radius: 0;
  height: 36px;
  user-select: none;
  position: relative;
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
  color: #fff;
  background-color: ${RGBA_COLORS.getAccent()};
  border-color: ${RGBA_COLORS.getAccent()};

  &:hover {
    color: #fff;
    background-color: ${RGBA_COLORS.getAccent(0.9)};
  }
  &:active {
    color: #fff;
    background-color: ${RGBA_COLORS.getAccent(0.7)};
    border-color: ${RGBA_COLORS.getAccent(0.7)};
  }
`;

export const BorderBtnS = styled(BtnS)`
  background: transparent;
  border-color: ${RGBA_COLORS.getDefault()};
  color: ${RGBA_COLORS.getDefault()};

  &:hover {
    border-color: ${RGBA_COLORS.getAccent(0.9)};
  }
  &:active {
    border-color: ${RGBA_COLORS.getAccent(0.7)};
  }
`;
